export default {
  title: 'モール装飾',
  previewTitle: 'モールセンター',
  pageSetting: 'ページ設定',
  pageTitle: 'ページタイトル',
  pageTitlePlaceholder: 'ページタイトルを入力してください',
  defaultPageTitle: 'マイページ',
  modules: 'モジュール',
  moduleList: 'モジュールリスト',
  moduleConfig: 'モジュール設定',
  editText: 'テキスト編集',
  editTextTitle: 'テキスト編集',
  moduleNames: {
    Banner: 'カルーセル',
    Picture: 'イメージショーケース',
  },
  labelName: {
    pointName: 'ポイント',
  },
  langSection: '言語バージョン',
  langEnglish: 'English',
  langZhTw: '繁體中文',
  langZhCn: '简体中文',
  langJaJp: 'Japanese',
  tabs: {
    title: 'ページタイトル',
    carousel: 'カルーセル画像',
    showcase: 'ショーケース画像',
  },
  delete: '削除',
  image: '画像',
  show: '表示',
  hide: '非表示',
  carouselTip:
    '最大5枚の画像をアップロードできます。非表示の場合、画像アップロード入口は表示されず、端末側のトップ画像も表示されません',
  uploadImage: '画像をアップロード',
  layout: 'レイアウト',
  layoutAlone: '一行占有',
  layoutBigOne: '大画像一行',
  layoutStack2: '二行積み重ね',
  unit: '単位',
  unitPlaceholder: '単位を入力してください',
  previewBack: '戻る',
  previewExchange: 'すぐに交換',
  previewAll: 'すべて',
  mockItemTitle: '商品名{index}',
  save: '保存',
  saveSuccess: '保存しました',
  syncConfig: '設定を同期',
  syncConfigTitle: '設定の同期',
  syncConfigDesc: '現在の言語（{lang}）の設定を以下に同期：',
  syncConfigSuccess: '同期が完了しました',
  formLabel: {
    isShow: '表示する',
    show: '表示',
    hide: '非表示',
    image: '画像',
    layoutType: 'レイアウトタイプ',
    layoutAlone: '一行占有',
    layoutBigOne: '大画像一行',
    layoutStack2: '二行積み重ね',
  },
};
